/**
 * CheckInSubmittedContent - Renders content for CheckInSubmitted timeline events
 * Shows factor name, status badge, and optional truncated comment preview
 */

import React, { useState } from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';
import {
  getStatusCssVar,
  getStatusLabel,
  ExtendedStatusValue,
} from '../../../../utils/statusColors';
import './CheckInSubmittedContent.scss';

interface CheckInSubmittedContentProps {
  event: TimelineEvent;
}

const COMMENT_TRUNCATE_LENGTH = 80;

const CheckInSubmittedContent: React.FC<CheckInSubmittedContentProps> = ({
  event,
}) => {
  const { t } = useTranslation();
  const [commentExpanded, setCommentExpanded] = useState(false);

  const factorName = (event.payload?.factorName ?? '') as string;
  const statusValue = (event.payload?.statusValue ?? 'unknown') as ExtendedStatusValue;
  const comment = (event.payload?.comment ?? '') as string;

  const isCommentLong = comment.length > COMMENT_TRUNCATE_LENGTH;
  const displayComment = commentExpanded || !isCommentLong
    ? comment
    : `${comment.slice(0, COMMENT_TRUNCATE_LENGTH)}…`;

  return (
    <div className="sphere-timeline-event__content-block">
      <div className="check-in-submitted">
        <div className="check-in-submitted__header">
          <span className="check-in-submitted__label">
            {t('statusPanel.timeline.checkedIn')}
          </span>
          <span className="check-in-submitted__factor-name">
            &ldquo;{factorName}&rdquo;
          </span>
          <span
            className="check-in-submitted__badge"
            style={{ backgroundColor: getStatusCssVar(statusValue) }}
          >
            {getStatusLabel(statusValue)}
          </span>
        </div>
        {comment && (
          <div className="check-in-submitted__comment">
            <p className="check-in-submitted__comment-text">
              {displayComment}
            </p>
            {isCommentLong && (
              <button
                type="button"
                className="check-in-submitted__toggle"
                onClick={() => setCommentExpanded((prev) => !prev)}
              >
                {commentExpanded
                  ? t('common.showLess')
                  : t('common.showMore')}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckInSubmittedContent;
